import type { IconData } from '@stacksjs/iconify-core'

export const toiletMan: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M30.5 9.5a6.5 6.5 0 1 1-13 0a6.5 6.5 0 0 1 13 0\"/><path d=\"M14.553 16.247c-1.858.103-3.097 1.894-2.51 3.66c1.517 4.568 3.354 8.72 4.584 11.316l1.138 11.002c.139 1.344 1.159 2.43 2.502 2.567c1.07.11 2.401.208 3.733.208a38 38 0 0 0 3.733-.208c1.344-.138 2.364-1.223 2.503-2.567l1.138-11.003c1.23-2.595 3.066-6.747 4.584-11.314c.587-1.767-.652-3.558-2.51-3.66A173 173 0 0 0 24 16c-3.969 0-7.199.123-9.447.247M24 34v11\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default toiletMan
